import React, { useState } from 'react';
import { get } from 'lodash';
// Redux Imports
import { useSelector } from 'react-redux';
// Global Component
import CustomButton from '../../../../components/CustomButton';
import Checkbox from '@material-ui/core/Checkbox';
// Style Imports
import './styles.scss';

export default function ExamHallAttempt() {
  // State
  const [state, setState] = useState({
    checkedA: false
  });
  // Reducers
  const examDetails = useSelector(state =>
    get(state, 'examHallReducer.livePlayerData', {})
  );

  const handleChange = event => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <div className="attempt-popup">
      <div className="flex-column height-100">
        <div className="detail-section">
          <div className="green">
            Maximum marks : {examDetails.MaximumMarks}
          </div>
          <div className="purple">MaximumTime : {examDetails.MaximumTime}</div>
          <div>Total Questions : {examDetails.PaperQuestion}</div>
        </div>
        <div className="instructions-section">
          <iframe
            src={examDetails.PaperInstruction}
            width="100%"
            height="100%"
            frameBorder="0"
            className="embed-iframe"
          />
        </div>
        <div className="continue-section">
          <div>
            <Checkbox
              checked={state.checkedA}
              onChange={handleChange}
              name="checkedA"
              color="primary"
            />
            I agree the
            <a
              href="https://ots.allenbpms.in/termscondition"
              style={{ paddingLeft: '3px' }}
            >
              Terms and Conditions
            </a>
          </div>

          <CustomButton
            name="Continue"
            handler={() => {
              window.open(examDetails.PaperAttemptURL, '_blank', "height=300,width=300");
            }}
            disabled={!state.checkedA}
            // progressShow={isLoginLoading}
            // className={isLoginLoading ? 'loading-btn' : ''}
          />
        </div>
      </div>
    </div>
  );
}
